/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import QuestionPage from './QuestionPage'
import { withStyles } from '@material-ui/core/styles/index'
import { styles } from './QuestionPageWrapper.styles'
import QuestionPageNavigation from './partials/QuestionPageNavigation'
import { Box, LinearProgress } from '@material-ui/core'
import SignupView from './SignupView'
import Prelander from './Prelander'

class QuestionPageWrapper extends PureComponent {
    state = { prelanderCompleted: false, prelanderAnswers: null }

    handlePrelanderAnswersChanged = answers => {
        this.setState({ prelanderAnswers: answers })
    }

    handlePrelanderCompleted = () => {
        this.setState({ prelanderCompleted: true })
    }

    render() {
        const { prelanderCompleted, prelanderAnswers } = this.state
        const {
            classes,
            questionPage,
            pageAlias,
            isLoading,
            activeStep,
            onNext,
            childNext,
            childPrev,
            questionPageRef,
            visitorSessionId,
            theme,
            layout
        } = this.props

        return (
            <Box>
                {questionPage && questionPage.id && (
                    <>
                        {questionPage.signupProcessType ? (
                            <SignupView
                                questionPage={questionPage}
                                onComplete={onNext}
                                theme={theme}
                                visitorSessionId={visitorSessionId}
                                layout={layout}
                            />
                        ) : questionPage.prelander && !prelanderCompleted ? (
                            <Prelander
                                prelander={questionPage.prelander}
                                onComplete={this.handlePrelanderCompleted}
                                onAnswersChanged={this.handlePrelanderAnswersChanged}
                                theme={theme}
                                layout={layout}
                                visitorSessionId={visitorSessionId}
                            />
                        ) : (
                            <QuestionPage
                                questionPage={questionPage}
                                onSubmit={onNext}
                                innerRef={questionPageRef}
                                alias={pageAlias}
                                isLoading={isLoading}
                                visitorSessionId={visitorSessionId}
                                theme={theme}
                                layout={layout}
                                prelanderAnswers={prelanderAnswers}
                            />
                        )}
                    </>
                )}
                {questionPage && questionPage.showNavigation && (
                    <QuestionPageNavigation
                        questionPage={questionPage}
                        isLoading={isLoading}
                        next={childNext}
                        prev={childPrev}
                        activeStep={activeStep}
                    />
                )}
                {isLoading && questionPage.showLoadingBar && (
                    <LinearProgress className={classes.loader} classes={{ root: classes.progressBarRoot, bar: classes.progressBarBar }} />
                )}
            </Box>
        )
    }
}

export default withStyles(styles)(QuestionPageWrapper)
